/** Canned narrative for the /conhecer guided tour — Autorização para Venda. */

export const TOUR_DOCUMENT = {
  title: "Autorização para Venda — Rua das Flores, 250",
  modelId: "autorizacao-venda-imovel",
  modelName: "Autorização para Venda de Imóvel",
  categoryLabel: "Corretores",
};

/** Complex form snapshot matching autorizacao.pdf content (tour demo). */
export const TOUR_FORM_FIELDS = [
  {
    id: "NOME_PESSOA_FISICA",
    label: "Nome do proprietário",
    value: "Roberto Silva Santos",
    section: "Autorizador (proprietário)",
  },
  {
    id: "CPF_PESSOA_FISICA",
    label: "CPF",
    value: "123.456.789-01",
    section: "Autorizador (proprietário)",
  },
  {
    id: "RG_PESSOA_FISICA",
    label: "RG",
    value: "12.345.678-9",
    section: "Autorizador (proprietário)",
  },
  {
    id: "NACIONALIDADE_PESSOA_FISICA",
    label: "Nacionalidade",
    value: "Brasileira",
    section: "Autorizador (proprietário)",
  },
  {
    id: "PROFISSAO_PESSOA_FISICA",
    label: "Profissão",
    value: "Engenheiro",
    section: "Autorizador (proprietário)",
  },
  {
    id: "ESTADO_CIVIL_PESSOA_FISICA",
    label: "Estado civil",
    value: "Casado(a)",
    section: "Autorizador (proprietário)",
  },
  {
    id: "NOME_CONJUGE",
    label: "Nome do cônjuge",
    value: "Ana Costa Silva",
    section: "Autorizador (proprietário)",
  },
  {
    id: "CPF_CONJUGE",
    label: "CPF do cônjuge",
    value: "444.555.666-77",
    section: "Autorizador (proprietário)",
  },
  {
    id: "EMAIL_PESSOA_FISICA",
    label: "E-mail",
    value: "roberto.silva@email.com",
    section: "Autorizador (proprietário)",
  },
  {
    id: "TEL_PESSOA_FISICA",
    label: "Telefone",
    value: "(11) 91234-5678",
    section: "Autorizador (proprietário)",
  },
  {
    id: "RUA_ENDERECO_PESSOA_FISICA",
    label: "Endereço",
    value: "Avenida Consolação, 500 — Consolação, São Paulo/SP",
    section: "Autorizador (proprietário)",
  },
  {
    id: "CEP_PESSOA_FISICA",
    label: "CEP",
    value: "01307-100",
    section: "Autorizador (proprietário)",
  },
  {
    id: "RAZAO_SOCIAL_IMOBILIARIA",
    label: "Razão social",
    value: "Imobiliária Brasil Ltda.",
    section: "Autorizado (intermediador)",
  },
  {
    id: "CNPJ_IMOBILIARIA",
    label: "CNPJ",
    value: "12.345.678/0001-95",
    section: "Autorizado (intermediador)",
  },
  {
    id: "NOME_REPRESENTANTE_LEGAL",
    label: "Representante legal",
    value: "Carlos Alberto Mendes",
    section: "Autorizado (intermediador)",
  },
  {
    id: "CPF_REPRESENTANTE_LEGAL",
    label: "CPF do representante",
    value: "111.222.333-44",
    section: "Autorizado (intermediador)",
  },
  {
    id: "ENDERECO_IMOBILIARIA",
    label: "Endereço da imobiliária",
    value: "Avenida Paulista, 1000 — Bela Vista, São Paulo/SP",
    section: "Autorizado (intermediador)",
  },
  {
    id: "IMOVEL_ENDERECO",
    label: "Endereço do imóvel",
    value: "Rua das Flores, 250 — Jardins, São Paulo/SP",
    section: "Imóvel e condições",
  },
  {
    id: "IMOVEL_AREA",
    label: "Área construída / terreno",
    value: "180 m² construídos · terreno 250 m²",
    section: "Imóvel e condições",
  },
  {
    id: "IMOVEL_MATRICULA",
    label: "Matrícula",
    value: "1.234.567 — 1º RI de São Paulo",
    section: "Imóvel e condições",
  },
  {
    id: "PRAZO_AUTORIZACAO",
    label: "Prazo da autorização",
    value: "6 meses (renovação automática)",
    section: "Imóvel e condições",
  },
  {
    id: "COMISSAO",
    label: "Comissão",
    value: "5,5% sobre o valor da negociação",
    section: "Imóvel e condições",
  },
];

export const TOUR_AI_MESSAGES = [
  {
    role: "assistant",
    text: "Esta função de preenchimento está em estágio beta e pode cometer erros. Descreva as informações que deseja preencher e a NeoAi cuida do resto.",
  },
  {
    role: "user",
    text: "Autorização de venda: proprietário Roberto Silva Santos CPF 123.456.789-01 casado com Ana Costa Silva, imóvel Rua das Flores 250 Jardins SP matrícula 1234567, imobiliária Imobiliária Brasil Ltda CNPJ 12.345.678/0001-95 representada por Carlos Alberto Mendes, prazo 6 meses, comissão 5,5%.",
  },
  {
    role: "assistant",
    text: "Pronto! Preenchi proprietário, cônjuge, intermediador, imóvel, prazo e comissão. Revise os campos destacados — são vários blocos neste modelo.",
  },
];

export const TOUR_AI_STATUS_LINES = [
  "Lendo suas informações…",
  "Mapeando proprietário, cônjuge e intermediador…",
  "Preenchendo dados do imóvel e matrícula…",
  "Aplicando prazo e comissão…",
  "Quase lá — finalizando o preenchimento…",
];

export const TOUR_PREVIEW_LINES = [
  "AUTORIZAÇÃO PARA VENDA DE IMÓVEL",
  "",
  "AUTORIZADOR: Roberto Silva Santos, CPF 123.456.789-01",
  "CÔNJUGE: Ana Costa Silva, CPF 444.555.666-77",
  "AUTORIZADO: Imobiliária Brasil Ltda. — Carlos Alberto Mendes",
  "",
  "IMÓVEL: Rua das Flores, 250 — Jardins, São Paulo/SP",
  "Área: 180 m² construídos · terreno 250 m² · Matrícula 1.234.567",
  "PRAZO: 6 meses  ·  COMISSÃO: 5,5%",
  "",
  "As partes firmam a presente Autorização para Intermediação de Negócio Imobiliário…",
];

/** A4 page size from autorizacao.pdf. Signature lines live on page 3. */
const PDF_W = 595.3;
const PDF_H = 841.89;

export const TOUR_SIGNATURE_FIELDS = [
  {
    signer_id: "tour-signer-roberto",
    full_name: "Roberto Silva Santos",
    email: "roberto.silva@email.com",
    cpf: "123.456.789-01",
    telefone: "",
    page_number: 3,
    x: 72,
    y: 480,
    width: 200,
    height: 44,
    page_relative: true,
    pdf_page_width_pt: PDF_W,
    pdf_page_height_pt: PDF_H,
    isDraft: false,
    isConfirmed: true,
  },
  {
    signer_id: "tour-signer-ana",
    full_name: "Ana Costa Silva",
    email: "ana.costa@email.com",
    cpf: "444.555.666-77",
    telefone: "",
    page_number: 3,
    x: 320,
    y: 480,
    width: 200,
    height: 44,
    page_relative: true,
    pdf_page_width_pt: PDF_W,
    pdf_page_height_pt: PDF_H,
    isDraft: false,
    isConfirmed: true,
  },
  {
    signer_id: "tour-signer-carlos",
    full_name: "Carlos Alberto Mendes",
    email: "carlos.mendes@imobiliaria.com",
    cpf: "111.222.333-44",
    telefone: "",
    page_number: 3,
    x: 72,
    y: 620,
    width: 220,
    height: 44,
    page_relative: true,
    pdf_page_width_pt: PDF_W,
    pdf_page_height_pt: PDF_H,
    isDraft: false,
    isConfirmed: true,
  },
];

export const TOUR_DASHBOARD_USER = {
  email: "roberto.silva@email.com",
  neo_coins: 120,
  activeLicense: {
    is_active: "true",
    license_name: "Plano Profissional",
    license_type: "Mensal",
    expires_at: "2026-12-31T23:59:59.000Z",
    documents_generated: 12,
    documents_signed: 3,
    max_documents: 50,
    max_signatures: 50,
  },
};

/** Same shape as dashboard `mapDocumentToContract` rows. */
export const TOUR_DASHBOARD_CONTRACTS = [
  {
    id: "tour-s3-autorizacao",
    name: TOUR_DOCUMENT.title,
    type: "autorizacao_venda_imovel",
    status: "PENDING_SIGNATURE",
    job_id: "tour-job-autorizacao",
    createdAt: "2026-09-15T14:32:00.000Z",
    signatureDate: null,
    s3Key: "tour-s3-autorizacao",
    is_manual: false,
    fillingType: "standard",
    template_id: null,
    is_custom_template: false,
    is_manual_signature: false,
  },
  {
    id: "tour-s3-recibo",
    name: "Recibo Simples — Demonstração",
    type: "recibo_simples",
    status: "PDF_GENERATED",
    job_id: "tour-job-recibo",
    createdAt: "2026-09-14T09:10:00.000Z",
    signatureDate: null,
    s3Key: "tour-s3-recibo",
    is_manual: false,
    fillingType: "standard",
    template_id: null,
    is_custom_template: false,
    is_manual_signature: false,
  },
  {
    id: "tour-s3-compra",
    name: "Compromisso de Compra e Venda — Demonstração",
    type: "compromisso_compra_venda",
    status: "DRAFT",
    job_id: "tour-job-compra",
    createdAt: "2026-09-13T11:05:00.000Z",
    signatureDate: null,
    s3Key: "tour-s3-compra",
    is_manual: false,
    fillingType: "standard",
    template_id: null,
    is_custom_template: false,
    is_manual_signature: false,
  },
];

export const TOUR_LIBRARY_MODELS = [
  { id: "compromisso-compra-venda", name: "Compromisso de Compra e Venda" },
  {
    id: "autorizacao-venda-imovel",
    name: "Autorização para Venda de Imóvel",
    highlight: true,
  },
  { id: "contrato-locacao-imovel", name: "Contrato de Locação de Imóvel" },
  { id: "recibo-simples", name: "Recibo Simples" },
];

/** Write-contract (/write-contract) NeoAi demo. */
export const TOUR_WRITE_CONTRACT_MESSAGES = [
  {
    role: "assistant",
    text: "Olá! Sou o NeoAi. Documento vazio: descreva o que precisa e eu elaboro o texto no editor. Com conteúdo, posso ajustar cláusulas ou inserir na posição do cursor.",
  },
  {
    role: "user",
    text: "Elabore um contrato de prestação de serviços entre Roberto Silva Santos (contratante) e Neo Serviços Digitais Ltda. (contratada), valor mensal de R$ 2.500,00, vigência de 12 meses, objeto consultoria em documentação digital.",
  },
  {
    role: "assistant",
    text: "Pronto! Inseri um contrato de prestação de serviços no editor. Revise as cláusulas e customize o que precisar.",
  },
];

export const TOUR_WRITE_CONTRACT_STATUS_LINES = [
  "Lendo suas instruções…",
  "Montando partes e objeto…",
  "Redigindo cláusulas de valor e vigência…",
  "Inserindo o texto no editor…",
];

export const TOUR_WRITE_CONTRACT_TITLE =
  "Contrato de Prestação de Serviços — Demonstração";

export const TOUR_WRITE_CONTRACT_BLOCKS = [
  {
    type: "heading",
    text: "CONTRATO DE PRESTAÇÃO DE SERVIÇOS",
  },
  {
    type: "p",
    text: "CONTRATANTE: Roberto Silva Santos, CPF 123.456.789-01, residente em São Paulo/SP.",
  },
  {
    type: "p",
    text: "CONTRATADA: Neo Serviços Digitais Ltda., CNPJ 98.765.432/0001-10, com sede em São Paulo/SP.",
  },
  {
    type: "heading",
    text: "CLÁUSULA 1 — DO OBJETO",
  },
  {
    type: "p",
    text: "A CONTRATADA prestará serviços de consultoria em documentação digital, incluindo elaboração, revisão e organização de documentos sob demanda do CONTRATANTE.",
  },
  {
    type: "heading",
    text: "CLÁUSULA 2 — DO VALOR",
  },
  {
    type: "p",
    text: "Pelos serviços, o CONTRATANTE pagará à CONTRATADA o valor mensal de R$ 2.500,00 (dois mil e quinhentos reais), até o 5º dia útil de cada mês.",
  },
  {
    type: "heading",
    text: "CLÁUSULA 3 — DA VIGÊNCIA",
  },
  {
    type: "p",
    text: "O presente contrato vigorará pelo prazo de 12 (doze) meses, podendo ser renovado mediante acordo escrito entre as partes.",
  },
];

/** Create-template (/create-template) NeoAi demo. */
export const TOUR_CREATE_TEMPLATE_MESSAGES = [
  {
    role: "assistant",
    text: "Olá! Sou o NeoAi. Ajudo você a elaborar modelos de documentos. Descreva o modelo desejado — gero o texto com campos variáveis como {NOME}, {CPF} ou {VALOR}.",
  },
  {
    role: "user",
    text: "Crie um modelo de Autorização para Venda de Imóvel com campos para proprietário, CPF, imobiliária, endereço do imóvel, matrícula, prazo e comissão.",
  },
  {
    role: "assistant",
    text: "Pronto! Montei o modelo com placeholders. Os campos aparecem na lista à esquerda — você pode renomear, tipar e ajustar o texto.",
  },
];

export const TOUR_CREATE_TEMPLATE_STATUS_LINES = [
  "Entendendo o modelo pedido…",
  "Definindo campos variáveis…",
  "Redigindo o texto com placeholders…",
  "Inserindo o modelo no editor…",
];

export const TOUR_CREATE_TEMPLATE_NAME = "Autorização para Venda — Personalizado";

export const TOUR_CREATE_TEMPLATE_FIELDS = [
  { key: "NOME_PROPRIETARIO", label: "Nome do proprietário", type: "text" },
  { key: "CPF", label: "CPF", type: "text" },
  { key: "NOME_IMOBILIARIA", label: "Nome da imobiliária", type: "text" },
  { key: "ENDERECO_IMOVEL", label: "Endereço do imóvel", type: "text" },
  { key: "MATRICULA", label: "Matrícula", type: "text" },
  { key: "PRAZO", label: "Prazo", type: "text" },
  { key: "COMISSAO", label: "Comissão", type: "text" },
];

/** Blocks with inline {TOKEN} markers for create-template reveal. */
export const TOUR_CREATE_TEMPLATE_BLOCKS = [
  {
    type: "heading",
    text: "AUTORIZAÇÃO PARA VENDA DE IMÓVEL",
  },
  {
    type: "p",
    text: "Eu, {NOME_PROPRIETARIO}, inscrito(a) no CPF sob o nº {CPF}, autorizo a {NOME_IMOBILIARIA} a intermediar a venda do imóvel situado em {ENDERECO_IMOVEL}, matrícula {MATRICULA}, pelo prazo de {PRAZO}, com comissão de {COMISSAO} sobre o valor da negociação.",
  },
  {
    type: "p",
    text: "O presente instrumento é firmado de livre e espontânea vontade, para que produza os efeitos legais.",
  },
];
